import { Set } from '../types'
import { set } from '../utils'

export interface User {
  _id: string
  email: string
  spaces: { _id: string; name: string }[]
}

interface ModelUser {
  // State
  space: string | null

  // Actions
  setSpace: Set<this, 'space'>
}

export const modelUser: ModelUser = {
  // State
  space: null,

  // Actions
  setSpace: set('space'),
}
